import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import FormularioJurado from '../../../components/auth/Formularios/FormularioJurado';
import useAuth from '../../../hooks/useAuth';

function StepFormularioJurado({ onSuccess }) {
  const { t } = useTranslation();
  const { user } = useAuth();
  const initialEmail = user?.email || '';

  // Obtém o conviteJuradoId do sessionStorage (salvo ao aceitar o convite)
  const conviteJuradoId = sessionStorage.getItem('konq.conviteJuradoId') || null;

  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant="h5" gutterBottom textAlign="center">
        {t('wizard.jurado.step2.title')}
      </Typography>
      <Typography variant="body2" mb={4} textAlign="center">
        {t('wizard.jurado.step2.subtitle')}
      </Typography>

      <FormularioJurado
        onSuccess={onSuccess}
        wizardMode
        initialEmail={initialEmail}
        conviteJuradoId={conviteJuradoId}
      />
    </Box>
  );
}

export default StepFormularioJurado;
